import { render, staticRenderFns } from "./ContactosWhatsApp.vue?vue&type=template&id=15bf6d65&scoped=true&"
import script from "./ContactosWhatsApp.vue?vue&type=script&lang=js&"
export * from "./ContactosWhatsApp.vue?vue&type=script&lang=js&"
import style0 from "./ContactosWhatsApp.vue?vue&type=style&index=0&id=15bf6d65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bf6d65",
  null
  
)

export default component.exports